const device = (function() {
  const ua = window.navigator.userAgent;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const NGPClient = /NGPClient/.test(ua);
  const nintendoBrowser = ua.match(/(NintendoBrowser)/);
  return {
    ios: ipad || iphone || ipod,
    android,
    purple: NGPClient,
    nintendoBrowser,
  };
})();

export default device;
